module.exports = __webpack_public_path__ + "static/img/アセット 45@3x.03ca533.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/アセット 45@3x.png
// module id = C1av
// module chunks = 1